module.exports = __webpack_public_path__ + "static/media/android_option.6f9a60e9.png";